import router from "../../router";

const receptions = {
  namespaced: true,
  state: {
    selected: null,
    cell: null,
    item: null,
  },
  mutations: {
    setSelected(state, payload) {
      state.selected = payload;
    },
    setItem(state, payload) {
      if (null === payload) {
        state.item = payload;
        return;
      }

      state.item = {
        ...payload,
        products: payload.products.map((product) => {
          product.cells = [];

          product.images = {
            small: [
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/388/" +
                product.article +
                "_1.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/388/" +
                product.article +
                "_2.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/388/" +
                product.article +
                "_3.jpg",
            ],
            big: [
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/origins/" +
                product.article +
                "_1.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/origins/" +
                product.article +
                "_2.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/origins/" +
                product.article +
                "_3.jpg",
            ],
          };

          return product;
        }),
      };

      if (null === state.selected) {
        this.commit("receptions/setSelected", payload.products[0]);
      }

      this.commit("receptions/setCell", null);

      this.commit("messages/setMessage", {
        type: "info",
        code: "Ой ли!",
        message: "Выгружен новый список товаров по приемке",
      });

      router.push({ name: "receptions" });
    },
    updateProductItem(state, payload) {
      const product = state.item.products.find(
        (product) =>
          String(product.size) === String(payload.size) &&
          parseInt(product.article) === parseInt(payload.article)
      );

      if (!product) {
        this.commit("messages/setMessage", {
          type: "warning",
          code: "Ой вей!",
          message:
            "Сервер пытается обновить товар, которого нет в интерфейсе приемки",
        });

        return;
      }

      const existsProductCell = product.cells.find(
        (cell) => cell.id === payload.cell.id
      );

      if (null === existsProductCell) {
        product.cells.push(payload.cell);
      }

      product.quantity_fact = product.quantity_fact + 1;

      if (product.quantity_fact > product.quantity_plan) {
        this.commit("messages/setMessage", {
          type: "warning",
          code: "Ой вей!",
          message:
            "В товар " +
            product.article +
            "  дДобавлено больше (" +
            product.quantity_fact +
            ") чем нужно (" +
            product.quantity_plan +
            ") едениц",
        });
      } else {
        this.commit("messages/setMessage", {
          type: "info",
          code: "Приемка!",
          message:
            "Товар " +
            product.article +
            " обновлен. Добавлено " +
            product.quantity_fact +
            " из " +
            product.quantity_plan +
            " единиц",
        });
      }

      this.commit("receptions/setSelected", product);

      router.push({ name: "receptions" });
    },
    setCell(state, payload) {
      if (null === payload) {
        state.cell = payload;
        return;
      }

      state.cell = payload;

      this.commit("messages/setMessage", {
        type: "info",
        code: "Остатки!",
        message: `Выбрана ячейка: "${payload.message}"`,
      });

      router.push({ name: "receptions" });
    },
  },
  actions: {},
  getters: {},
};

export default receptions;
